import React from "react";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { PageHeader } from "../../layout/AppLayout";
import { Alert } from "../../components/erp";
import { errorText } from "../../api/client";
import { paymentVoucherApi } from "./api";

/** Port of ApiV2/RmPurchase/RmPaymentVoucherReport.php (cash/bank/journal payment voucher print). */
export default function PaymentVoucher() {
  const [params] = useSearchParams();
  const p = { PayDate: params.get("PayDate") || "", VoucherNo: params.get("VoucherNo") || "", BillerType: params.get("BillerType") || "0", SupplierID: params.get("SupplierID") || undefined };
  const q = useQuery({ queryKey: ["purchase", "payment-voucher", p], enabled: !!p.PayDate && !!p.VoucherNo, queryFn: () => paymentVoucherApi.report(p) });
  const v = q.data?.Data?.PaymentVoucherReportData; const b = q.data?.Data?.BillNumbers;
  return (
    <>
      <PageHeader title="Payment Voucher" location="Purchase" />
      {q.isError && <Alert kind="danger" testId="voucher-error">{errorText(q.error)}</Alert>}
      {q.isLoading && <div className="p-3"><span className="erp-spinner" /> Loading voucher...</div>}
      {v && (
        <div className="card" style={{ maxWidth: 640 }}><div className="card-body" data-testid="payment-voucher-view">
          <div className="text-center border-bottom pb-2 mb-3"><h5 className="mb-0" data-testid="voucher-company">{v.CompanyName}</h5><small className="text-muted">GST: {v.GSTNumber}</small><div>{v.Address}</div></div>
          <div className="row mb-2">
            <div className="col-6"><div className="text-muted" style={{ fontSize: 12 }}>Voucher No</div><div className="fw-semibold">{p.VoucherNo}</div></div>
            <div className="col-6"><div className="text-muted" style={{ fontSize: 12 }}>Cheque No</div><div className="fw-semibold">{v.ChequeNO || "-"}</div></div>
          </div>
          <div className="mb-2"><div className="text-muted" style={{ fontSize: 12 }}>Paid To</div><div className="fw-semibold" data-testid="voucher-supplier">{b?.SupplierName}</div></div>
          <div className="mb-2"><div className="text-muted" style={{ fontSize: 12 }}>Against Bills</div><div data-testid="voucher-bills">{b?.BillNos}</div></div>
          <div className="row border-top pt-2">
            <div className="col-6"><div className="text-muted" style={{ fontSize: 12 }}>Amount</div><div className="fw-bold fs-5" data-testid="voucher-amount">{v.Amount}</div></div>
            <div className="col-6"><div className="text-muted" style={{ fontSize: 12 }}>In Words</div><div data-testid="voucher-amount-words">{v.AmountinRupees}</div></div>
          </div>
        </div></div>
      )}
    </>
  );
}
